<div class="content">

    <div class="text-left mt-5">

        <h3>Get All Job Details</h3><br>

        <p>Call following API to get Job details</p>


        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <pre><code [innerHTML]="jsonData" ></code></pre>
            </div>
        </div><br>


        <div class="card text-bg-light mb-3">
            <div class="card-body">
                <!-- <button style="float: right;" type="button" class="btn btn-danger btn-sm" (click)="close()">
                    <i class="fa fa-close mr-2"></i>
                </button> -->

                <div class="panel panel-primary">
                    <div class="tab-menu-heading">
                        <ul class="nav nav-pills" role="tablist">
                            <!-- Tab menu items -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                    data-bs-target="#content1" type="button" role="tab" aria-controls="content1"
                                    aria-selected="true">200</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content2"
                                    type="button" role="tab" aria-controls="content2"
                                    aria-selected="false">401</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#content4"
                                    type="button" role="tab" aria-controls="content4"
                                    aria-selected="false">404</button>
                            </li>
                        </ul>
                    </div>

                    <div class="panel-body tabs-menu-body mt-4">
                        <div class="tab-content">
                            <!-- Tab content -->
                            <div class="tab-pane fade show active" id="content1" role="tabpanel"
                                aria-labelledby="tab1">
                                <div class="card-body">
                                    <pre><code [innerHTML]="sucessData" ></code></pre>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="content2" role="tabpanel" aria-labelledby="tab2">
                                <div class="card-body">
                                    <pre><code [innerHTML]="Error5x" ></code></pre>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="content4" role="tabpanel" aria-labelledby="tab4">
                                <div class="card-body">
                                  <pre><code [innerHTML]="Error401x" ></code></pre>
                                </div>
                              </div>

                        </div>
                    </div>
                </div>

            </div>
        </div><br><br>


        <h3>API doc link:</h3><br>


        <ul>
            <li>
              <a routerLink="/apilist/joblist" target="_blank"><h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> List Jobs [Customer]</h5></a>
            </li>
          </ul>

        <!-- <p><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/customerJobList">
                http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/customerJobList
            </a></p> -->


    </div>

</div>